export const SUBSCRIPTION = {
  REQUEST: "SUBSCRIPTION_REQUEST",
  SUCCESS: "SUBSCRIPTION_SUCCESS",
  FAILURE: "SUBSCRIPTION_FAILURE",
};

export const CANCEL_SUBSCRIPTION = {
  REQUEST: "CANCEL_SUBSCRIPTION_REQUEST",
  SUCCESS: "CANCEL_SUBSCRIPTION_SUCCESS",
  FAILURE: "CANCEL_SUBSCRIPTION_FAILURE",
};